<template>
	<div>
		<GenericSelector
			:value="value"
			@input="val => handleInput(val)"
			:options="options"
			:stations="stations"
			:showOptions="showOptions"
			:canEdit="showOptions"
			:loading="!users"
			:displayCb="displayCb"
			:disableNoneSelectedAlert="disableNoneSelectedAlert"
			:hideSelected="showSelectedOnEdit ? !showOptions : hideSelected"
		>	
			<template v-if="label" v-slot:selectedHeader>
				<slot name="label">
					<div class="list-group-item text-sm font-weight-bold">{{ label }}</div>
				</slot>
			</template>		
			
			<template v-slot:selected="{ option }">
				<div class="row">
					<div class="col-6">
						{{ option.displayname }}
					</div>
					<div class="col-6">
						<div class="float-right" v-if="stations">
							<button 
								v-for="station in stations" 
								:key="station.id"
								class="ml-2 btn btn-sm"
								:class="{'btn-primary': option.stations.includes(station.id), 'btn-light': !option.stations.includes(station.id)}"
								@click.stop="handleToggleStation(option, station.id)"
							>
							  {{ station.code }}: {{ station.title }}
							</button>
							<b-icon v-if="showOptions" icon="dash-circle-fill" class="ml-2 mt-0 mb-0" />
						</div>
					</div>
				</div>
			</template>
			
			<template v-slot:unselectedHeader>
				<div class="pl-3 my-2 d-flex flex-row align-items-center" style="gap: 1rem">
					<SearchBar v-if="showOptions" v-model="search" :debounce="false" />

					<button
						type="button"
						@click="showOptions = !showOptions"
						class="btn btn-primary ml-auto"
					>
						<b-icon v-if="!showOptions" icon="plus" class="h6 mb-0 mr-1"/>{{ showOptions ? $t('done') : $t('edit') }}
					</button>
				</div>
			</template>
		</GenericSelector>
	</div>
</template>

<script>
import GenericSelector from '../Inputs/GenericSelector.vue';
import SearchBar from '../Table/SearchBar.vue';

export default {
	components: {
		GenericSelector,
		SearchBar,
	},
    props: {
		value: Array,
		users: Array,
		loading: {
			type: Boolean,
			default: false,
		},
		displayCb: {
			type: Function,
			default: user => user.displayname,
		},
		label: String,
		disableNoneSelectedAlert: Boolean,
		hideSelected: Boolean,
		showSelectedOnEdit: Boolean,
        limit: Number,
		stations: {
			type: Array,
			default: () => []
		}
	},
    data() {
        return {
			search: '',
			showOptions: false,
        };
    },
    methods: {
        handleInput(value){
            if(value.length > this.limit) value.shift();
            this.$emit('input', value)
        },
        handleToggleStation(user, station){
        	if(user.stations.includes(station)){
        		user.stations.splice(user.stations.indexOf(station), 1);
        	} else {
        		user.stations.push(station)
        	}
        }
    },
    computed: {
		options() {
			return this.users.filter(user => !this.search
				|| user.displayname && user.displayname.toLowerCase().includes(this.search.toLowerCase())
				|| user.username && user.username.toLowerCase().includes(this.search.toLowerCase())
			)
		},
    },
};
</script>
